import React from "react";
import styled from "styled-components";
import { getYear } from "date-fns";
import LogoImg from "lib/images/loanbossLogoBlack.png";

const Wrapper = styled.div`
  padding: 12px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Description = styled.div`
  font-size: 6px;
  line-height: 7px;
  color: #000;
  max-width: 409px;
`;

const LogoRoot = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 10px;
  line-height: 12px;
  color: #5f6368;
`;

const Logo = styled.img`
  width: 76px;
  margin-left: 8px;
`;

const updateYear = footerText => {
  const currentYear = getYear(new Date()).toString();

  return footerText.replaceAll("%YEAR%", currentYear);
};

const Footer = ({ footerText }) => (
  <Wrapper>
    <Description>
      {updateYear(footerText)}
    </Description>
    <LogoRoot>
      Powered by
      <Logo src={LogoImg} alt="LoanBoss" />
    </LogoRoot>
  </Wrapper>
);

export default Footer;
